import { Dispatch, useEffect, useRef } from 'react';
import { flow } from 'fp-ts/lib/function';
import { pathOr } from 'rambda';
import { RequestAction, IRequestState } from '.';
import { csosUpmApi } from '../common'; // adjust import to match your project
import { useUserContext } from '../common'; // adjust to match your user/auth hook

export function useDeaNumFetch({
    requestState,
    dispatchRequest,
}: {
    requestState: IRequestState;
    dispatchRequest: Dispatch<RequestAction>;
}) {
    const { user } = useUserContext();
    // Track which keys we've already kicked off a fetch for
    const fetchedKeys = useRef<Set<string>>(new Set());

    useEffect(() => {
        requestState.request.deaInfos
            .filter(
                d =>
                    d.fetchStatus === 'loading' &&
                    !fetchedKeys.current.has(d.key)
            )
            .forEach(d => {
                fetchedKeys.current.add(d.key);

                csosUpmApi(user.icam!.headers)
                    .post(`v1/api/upm/legacy/csa-search?page=0&size=1`, {
                        deaNumber: d.deaNum,
                        chainCodeFlag: true,
                        ssn: null,
                        taxId: null,
                        npi: null,
                        city: null,
                        state: null,
                        postalCd: null,
                    })
                    .then(result =>
                        dispatchRequest({
                            type: 'UpdateDeaNum',
                            payload: {
                                ...d,
                                expDt: result.data.content[0]?.expirationDate ?? null,
                                fetchStatus: null,
                                editMode: 'Read',
                                msgCode: null,
                                msgText: null,
                                serialNumber: null,
                            },
                        })
                    )
                    .catch(e =>
                        dispatchRequest({
                            type: 'UpdateDeaNum',
                            payload: {
                                ...d,
                                fetchStatus: 'error',
                                editMode: 'Read',
                                msgCode: null,
                                msgText: pathOr('Failed to fetch expiration date', 'response.data.message')(e),
                                serialNumber: null,
                            },
                        })
                    );
            });
    }, [requestState.request.deaInfos]);
}